import { styled } from 'styled-components';

import { Button } from '@src/components/atoms/inputs/button';
import { P } from '@src/components/atoms/paragraph';

export const LoggedInHeader = styled.header`
  background-color: var(--color-white);
  width: 100%;
  padding-top: 27px;
  padding-bottom: 69px;

  @media screen and (min-width: 768px) {
    padding-top: 44px;
    padding-bottom: 60px;
  }
`;

export const LoggedOutHeader = styled.header`
  padding-top: 32px;
  width: 100%;
  min-height: 567px;
  background-color: var(--color-white);

  @media screen and (min-width: 768px) {
    padding-top: 40px;
    min-height: 100vh;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-top: 24px;

  @media screen and (min-width: 768px) {
    gap: 100px;
    flex-direction: column;
    margin-top: 0px;
  }
`;

export const SignUpCTA = styled(Button)`
  && {
    width: calc(100% - 40px);
    max-width: 375px;
    margin-top: 24px;
    margin-inline: auto;
    text-wrap: balance;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  padding-inline: var(--grid-margin);
  text-wrap: balance;

  p {
    font: 400 16px / 19px var(--font-family-founders-grotesk);
  }

  h1 {
    text-align: center;
    font: var(--font-h2);
  }

  @media screen and (min-width: 768px) {
    max-width: 900px;
    margin: 0 auto;
    p {
      max-width: 600px;
      text-align: center;
      margin: 0 auto;
      font: 400 20px / 26px var(--font-family-founders-grotesk);
    }
  }
`;

export const InfiniteGalleryWrapper = styled.div`
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media screen and (min-height: 668px) {
    gap: 14px;
  }

  @media screen and (min-width: 768px) {
    gap: 24px;
  }
`;

export const InfiniteGalleryImage = styled.img`
  display: block;
  width: 135px;
  height: 90px;
  object-fit: cover;

  @media screen and (min-height: 668px) {
    width: 155px;
    height: 100px;
  }

  @media screen and (min-width: 768px) {
    width: 280px;
    height: 180px;
  }
`;

export const StartExploring = styled(P)`
  margin-top: 8px;
  margin-bottom: 36px;
`;

export const LinkTripExploreWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 355px;
  margin-inline: auto;

  h1 {
    max-width: 335px;
    width: 100%;
    text-align: center;
    margin-inline: auto;
    font: var(--font-h2);
  }

  a {
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    p {
      max-width: 232px;
      width: 100%;
      text-align: center;
      margin-inline: auto;
    }
  }
`;

export const IllustrationWrapper = styled.div`
  margin-bottom: 16px;
  @media screen and (min-width: 768px) {
    margin-bottom: 24px;
  }
`;
